<template>
  <div class="patient-info">
    <div class="readonly-header">
      <div class="line">
        <span class="label">患者姓名：</span>
        <span class="value">{{ patientData?.realname || '-' }}</span>
      </div>
      <div class="line">
        <span class="label">性别：</span>
        <span class="value">{{ patientData?.sexText || '-' }}</span>
      </div>
      <div class="line">
        <span class="label">年龄：</span>
        <span class="value">{{ patientData?.age ? (patientData.age + '岁') : '-' }}</span>
      </div>
      <div class="line">
        <span class="label">就诊科室：</span>
        <span class="value">{{ patientData?.departmentName || '-' }}</span>
      </div>
      <div class="line">
        <span class="label">就诊日期：</span>
        <span class="value">{{ formatDate(patientData?.clinicCheckinTime || patientData?.visitDate) || '-' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PatientInfo',
  props: {
    patientData: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
  }
};
</script>

<style lang="less" scoped>
.patient-info {
  margin-bottom: 0;
  //padding: 0 1.25rem;
  background: transparent; // 使用透明背景，让父容器的浅灰色背景显示出来

  .readonly-header {
    margin-bottom: 8px;
    padding: 0;
    background: transparent; // 使用透明背景，让父容器的浅灰色背景显示出来
    border: none;
    border-radius: 0;

    .line {
      display: flex;
      align-items: flex-start;
      margin: 6px 0;
      color: #666;
      font-size: 12px;
      gap: 0.5rem; // 与字段标题和内容之间的间距保持一致

      .label {
        flex-shrink: 0;
        width: 80px; // 与字段标题宽度保持一致
        color: #333;
        font-weight: 600;
        line-height: 28px; // 与字段标题行高保持一致
        padding-top: 4px; // 与字段标题padding保持一致
        font-size: 14px; // 与字段标题字体大小保持一致
      }

      .value {
        color: #555;
        flex: 1;
      }
    }
  }
}
</style>

